import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {ICsListViewLayoutParams, ICsPagingParams} from '@app/shared/cs-components/cs-components.interface';
import {GridApi} from 'ag-grid-community';
import {CsAgGridService} from '@app/shared/cs-components/cs-ag-grid/cs-ag-grid.service';
import {ICsAgGridAutoHeightParams} from '@app/shared/cs-components/cs-ag-grid/cs-ag-grid.interface';
import {Subject} from 'rxjs';

@Component({
    selector: 'app-cs-list-view-layout',
    templateUrl: './cs-list-view-layout.component.html',
    styleUrls: ['cs-list-view-layout.component.scss'],
    providers: [CsAgGridService]
})
export class CsListViewLayoutComponent implements OnInit {

    @ViewChild('gridHolder') gridHolder: ElementRef;
    @ViewChild('gridWrapper') gridWrapper: ElementRef;
    @ViewChild('grid') grid: ElementRef;

    @Output() onLayoutReady = new EventEmitter<ICsListViewLayoutParams>();
    @Output() onPagingUpdate = new EventEmitter<ICsListViewLayoutParams>();
    @Output() onDefaultHeaderAction = new EventEmitter<{action: string}>();

    @Input() isDisplayPanel = false;
    @Input() isCustomHeaderAction = false;
    @Input() totalRecordCount: number;
    @Input() maxPagesDisplayLength = 5;
    @Input() csListViewParams: ICsListViewLayoutParams;
    @Input() borderWrapper = true;
    @Input() filterPanel = false;
    @Input() filterList: object[];

    gridAutoHeightParams: ICsAgGridAutoHeightParams;
    filterWidthChangeEvent = new Subject<any>();
    appliedFilter: any[] = [];
    isFilterActive = false;
    resetPagination: () => void;

    constructor(private _csAgGrid: CsAgGridService) {
    }

    ngOnInit() {
        this.setCsListViewParams();
        this.prepareGridAutoHeightParams();
        this.afterLayoutReady();
    }

    setCsListViewParams() {
        this.csListViewParams.pageSize = this.csListViewParams.pageSize || 5;
        this.csListViewParams.currentPage = this.csListViewParams.currentPage || 1;
        this.csListViewParams.setGridAutoHeight = this.setGridAutoHeight;
        this.csListViewParams.updateGridData = this.updateGridData;
        this.csListViewParams.initGrid = this.initGrid;
        this.csListViewParams.reset = this.reset;
    }

    prepareGridAutoHeightParams() {
        this.gridAutoHeightParams = {
            gridHolder: this.gridHolder,
            gridWrapper: this.gridWrapper,
            grid: this.grid,
            gridApi: this.csListViewParams.gridApi,
            gridLayout: 'normal',
            detailPanelsHeight: 0,
            pageSize: this.csListViewParams.pageSize
        };
    }

    afterLayoutReady() {
        this.onLayoutReady.emit(this.csListViewParams);
    }

    initGrid = (gridApi: GridApi) => {
        this.csListViewParams.gridApi = gridApi;
        this.gridAutoHeightParams.gridApi = gridApi;
        this._csAgGrid.renderGridSSData(this.csListViewParams);
    }

    onPaginationInit(param: { reset: () => void }) {
        this.resetPagination = param.reset;
    }

    updatePagingParams(params: ICsPagingParams) {
        Object.entries(params).forEach(([prop, val]) => {
            this.csListViewParams[prop] = val;
        });

        this.onPagingUpdate.emit(this.csListViewParams);

        this.gridAutoHeightParams.pageSize = this.csListViewParams.pageSize;

        if (this.csListViewParams.currentEvent && this.csListViewParams.currentEvent !== 'none') {
            this.updateGridData();
        }
    }

    onSearch(val: string) {
        this.csListViewParams.search = val;
        this.updateDataWithFilters();
    }

    onFilter(param: object | number, action: 'apply' | 'remove') {
        if (action === 'apply') {
            this.appliedFilter.push(param);
        } else if (action === 'remove') {
            this.appliedFilter.splice(param as number, 1);
        }

        this.csListViewParams.filters = this.appliedFilter;
        this.updateDataWithFilters();
    }

    defaultHeaderAction(action: string) {
        this.onDefaultHeaderAction.emit({action});
    }

    updateDataWithFilters() {
        this.isFilterActive = true;
        this.updateGridData();
    }

    updateGridData = (param?: any) => {
        if (this.csListViewParams.gridType === 'ag-grid') {
            this._csAgGrid.updateGridPagingData(this.csListViewParams);
        }
    }

    setGridAutoHeight = (detailPanelsHeight = 0) => {
        if (this.csListViewParams.gridType === 'ag-grid') {
            this._csAgGrid.setGridAutoHeight(this.gridAutoHeightParams, detailPanelsHeight);
        }
    }

    reset = () => {
        this.csListViewParams.setGridAutoHeight();
        if (this.isFilterActive) {
            this.resetPagination();
            this.isFilterActive = false;
        }
    }
}
